import {
  UPDATE_TEXT_ALERT_DELIVERY_STATUS,
  UPDATE_TEXT_ALERT_CONDITIONS,
  UPDATE_TEXT_ALERT_PHONE_NUMBER_DETAILS, TEXT_ALERT_SETTINGS_SUCCESS,
  TEXT_ALERT_SETTINGS_LOADING,
  TEXT_ALERT_SETTINGS_ERROR,
  RESET_TEXT_ALERT_PREFERENCES,
  SAVE_TEXT_ALERT_SETTINGS_ERROR, SAVE_TEXT_ALERT_SETTINGS_SUCCESS,
  SAVE_TEXT_ALERT_SETTINGS_LOADING,
  CLOSE_TEXT_ALERT_PREFERENCES_BANNER,
} from 'constants/ActionTypes';
import cloneDeep from 'lodash/cloneDeep';
import { t } from 'i18next';
import { SUCCESS, ERROR } from 'constants/AppConstants';
import { getNewAlert } from './TextAlertSettings.utils';

const initTextPreferencesBanner = {
  open: false,
  severity: '',
  title: '',
  message: '',
};

const initState = {
  textAlertPreferences: {},
  updatedTextAlertPreferences: {},
  mobileProviders: [],
  textAlerts: [],
  loading: false,
  loadError: false,
  saveLoading: false,
  textPreferencesBanner: initTextPreferencesBanner,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case TEXT_ALERT_SETTINGS_SUCCESS: {
      return {
        ...state,
        textAlertPreferences: action.textAlertPreferences,
        mobileProviders: action.mobileProviders,
        textAlerts: action.textAlerts,
        loading: false,
        loadError: false,
      };
    }
    case TEXT_ALERT_SETTINGS_LOADING: {
      return {
        ...state,
        loading: true,
        textPreferencesBanner: initTextPreferencesBanner,
      };
    }
    case TEXT_ALERT_SETTINGS_ERROR: {
      return {
        ...state,
        loading: false,
        loadError: true,
      };
    }
    case UPDATE_TEXT_ALERT_PHONE_NUMBER_DETAILS: {
      return {
        ...state,
        updatedTextAlertPreferences: {
          ...state.updatedTextAlertPreferences,
          [action.targetId]: action.value,
        },
      };
    }
    case UPDATE_TEXT_ALERT_CONDITIONS: {
      const { alertId, checked } = action;
      const existingAlerts = state.updatedTextAlertPreferences?.alerts || state.textAlertPreferences?.alerts || [];
      const alertIndex = existingAlerts.findIndex((alert) => alert.alertId === Number(action.alertId));

      const updatedAlerts = cloneDeep(existingAlerts);
      if (alertIndex !== -1) updatedAlerts[alertIndex].active = checked;
      else updatedAlerts.push(getNewAlert(alertId));

      return {
        ...state,
        updatedTextAlertPreferences: {
          ...state.updatedTextAlertPreferences,
          alerts: updatedAlerts,
        },
      };
    }
    case UPDATE_TEXT_ALERT_DELIVERY_STATUS: {
      return {
        ...state,
        updatedTextAlertPreferences: {
          ...state.updatedTextAlertPreferences,
          receiveSMSAlerts: action.status,
        },
      };
    }
    case RESET_TEXT_ALERT_PREFERENCES: {
      return {
        ...state,
        loading: false,
        loadError: false,
        updatedTextAlertPreferences: {},
        textPreferencesBanner: initTextPreferencesBanner,
      };
    }
    case SAVE_TEXT_ALERT_SETTINGS_SUCCESS: {
      return {
        ...state,
        saveLoading: false,
        textPreferencesBanner: { open: true, severity: SUCCESS, message: t('text_alert_settings__save_success_message') },
        updatedTextAlertPreferences: {},
        textAlertPreferences: action.textAlertPreferences,
      };
    }
    case SAVE_TEXT_ALERT_SETTINGS_ERROR: {
      return {
        ...state,
        saveLoading: false,
        textPreferencesBanner: {
          open: true,
          severity: ERROR,
          message: action.errors || t('text_alert_settings__save_error_message'),
        },
      };
    }
    case SAVE_TEXT_ALERT_SETTINGS_LOADING: return { ...state, saveLoading: true, textPreferencesBanner: initTextPreferencesBanner };
    case CLOSE_TEXT_ALERT_PREFERENCES_BANNER: return { ...state, textPreferencesBanner: initTextPreferencesBanner };
    default:
      return state;
  }
};
